import { render, staticRenderFns } from "./EnableStaticNat.vue?vue&type=template&id=549b99c4&scoped=true&"
import script from "./EnableStaticNat.vue?vue&type=script&lang=js&"
export * from "./EnableStaticNat.vue?vue&type=script&lang=js&"
import style0 from "./EnableStaticNat.vue?vue&type=style&index=0&id=549b99c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549b99c4",
  null
  
)

export default component.exports